import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { ConsignorService } from '../../_services/_masters/consignor.service';
import { BranchMasterService } from '../../_services/_masters/branch-master.service';
import { environment } from '../../../environments/environment';
import { Http, RequestOptions, Headers, Response } from '@angular/http';
import { Subject } from 'rxjs';
import 'rxjs/add/operator/map';
import swal from 'sweetalert2';

@Component({
	selector: 'app-lr-freight-master',
	templateUrl: './lr-freight-master.component.html',
	styleUrls: ['./lr-freight-master.component.css']
})
export class LrFreightMasterComponent implements OnInit {
	file_to_upload : File = null;
	url = environment.url
	formData:FormData = new FormData
	fileName :string;
	// stations : string[] = ['LATUR', 'OSMANABAD', 'Admin'];
	// clients : string[] = ['AMBUJA CEMENT LTD.', 'MAHARASHTRA STATE WEARHOUSING CORP.', 'RASHTRIYA CHEMICALS & FERTILIZERS LTD. (K)', 'Consignor 1', 'Consignor 2', 'Consignor 3','Consignor 4', 'Consignor 5', 'Consignor 6','MEGHNEEL C ADKE'];
	stations : string[] =[];
	products : string[] = [];
	consignors: any[] = [];

	lRFreightMaster : FormGroup;

	response :any = null;
	check_branch: boolean = true;

	currentUser  : any ;
	token : any ;
	user_role : string = null ;
	user_branch : string = null ;

	selected_client : string = null;

	constructor(private cd: ChangeDetectorRef, 
		private selectConsignorService : ConsignorService,
		private selectBranchService : BranchMasterService,
		private http : Http) {}

	ngOnInit() {
		this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
		this.token = this.currentUser.token;
		this.user_role = this.currentUser.role;
		this.user_branch = this.currentUser.branch;
		console.log(this.user_role);
		console.log(this.user_branch);

		this.lRFreightMaster = new FormGroup({ 
			'client': new FormControl(null , Validators.required),
			'file': new FormControl(null , Validators.required),
			'branch': new FormControl(null , Validators.required)
		});

			
		if(localStorage.getItem('currentUser'))
		{
			if (this.user_role === 'Admin')
			{
				this.getBranch();
				this.getConsignorBySelectedBranch(null);
				this.check_branch = false;
			}
			else if(this.user_role === 'Manager' || this.user_role === 'Employee')
			{
				this.lRFreightMaster.get('branch').setValue(this.user_branch);
  				this.stations.push(this.user_branch);
				this.getConsignorBySelectedBranch(this.user_branch);
				this.check_branch = true;
			}
		}


		// this.lRFreightMaster.patchValue({
		// 	'branch': this.user_branch
		// });
	}

	onFileChange(event) {
		// this.formData.delete('lr_rate_card_file');
		const fileList: FileList = event.target.files;
		console.log('', event.target.files);
		console.log('', event.target.value);
		if (fileList.length > 0) {
			const file: File = fileList[0];
			this.formData.append('lr_rate_card_file', file, file.name);
			this.fileName = file.name;
			console.log(this.formData);
			console.log(file);

		}
	}

	onSubmit(){
		this.selected_client = this.lRFreightMaster.get('client').value;
		this.user_branch = this.lRFreightMaster.get('branch').value;
		this.formData.append('client', this.selected_client);
		this.formData.append('branch', this.user_branch);
		console.log(this.selected_client)
		console.log ('ng Submit')
		const headers = new Headers();
		const options = new RequestOptions({ headers: headers });
		const path = this.url + '/upload/lr/ratecard';
		this.http.post(path, this.formData, options)
		.subscribe(res => {
			this.response = JSON.parse(res.json());
			console.log(this.response.status)
			if (this.response.status){
				swal(
					'LR Rate-Card Uploaded Successfully',
					'Selected Client :  <strong>' + this.selected_client +'</strong>' ,
					'success'
				);
			}
		},error =>{
			swal(
				'LR Rate-Card Uploading failed',
				'Please Reload the Page',
				'error'
			);
		}
		);
		this.formData.delete('lr_rate_card_file');
	}
	getBranch()
    {
     	this.selectBranchService.getBranches()
		.subscribe(
			branches => {
				for(var i=0;i<branches.length;i++)
				{
					this.stations.push(branches[i]['branch_name']);
				}
			});
    }
	getConsignor()
    {
     	this.selectConsignorService.getAllConsignor()
		.subscribe(
			consignors => {
				for(var i=0;i<consignors.length;i++)
				{
					this.consignors.push(consignors[i]['consignor_name']);
				}
			});
    }
    getConsignorBySelectedBranch(branch)
    {
    	this.consignors=[];
     	this.selectConsignorService.getConsignorFormWithBranch(branch)
		.subscribe(
			consignors => {
				//alert(consignors);
				
				for(var i=0;i<consignors.length;i++)
				{
					this.consignors.push(consignors[i]['consignor_name']);
				}
			});
    }




}



// WEBPACK FOOTER //
// /Users/meghneel/work/shree_translogic_dashboard/src/app/masters/lr-freight-master/lr-freight-master.component.ts